// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:37:54

export default {
  "id": "my-farm",
  "slug": "my-farm",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/2462cc3bf4d84d7aa1e892a8113869d7-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/2462cc3bf4d84d7aa1e892a8113869d7/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "My Farm",
      "description": "Become the proud owner of your very own farm! Grow crops, tend to animals, catch fish, and set up production. Assemble collections of exotic animals in the zoo, meet the mysterious visitors, and embark on thrilling adventures!",
      "instructions": "My Farm is an enthralling farming game with a tried and tested gameplay formula adored by millions of players! Develop your farm, manufacture new types of goods, and complete exciting tasks! Get rare Chests, exotic animals, and colorful decorations for your farm! Find your friends and make new ones! Create farmers guilds together, send each other gifts, and take part in nail-biting tournaments and fun theme festivities!",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "farm"
      ]
    },
    "zh-CN": {
      "title": "我的农场",
      "description": "成为你自己的农场的自豪主人！种植作物、照顾动物、捕鱼并建立生产线。在动物园中收集珍奇动物，遇见神秘的访客，踏上激动人心的冒险之旅！",
      "instructions": "我的农场是一款扣人心弦的农场游戏，拥有经过验证的游戏公式，深受数百万玩家喜爱！发展你的农场，制造新型商品，并完成激动人心的任务！获得稀有的宝箱、异国动物和五彩缤纷的装饰！寻找你的朋友，结识新朋友！一起创建农民公会，互相赠送礼物，并参与紧张刺激的锦标赛和有趣的主题庆典！",
      "genres": [
        "模拟"
      ],
      "tags": [
        "农场"
      ]
    },
    "zh-TW": {
      "title": "我的農場",
      "description": "成為您個人自豪的農場主人！種植作物、照顧動物、捕魚，並設立生產線。在動物園中組織珍奇動物收藏，遇見神秘的訪客，並踏上刺激的冒險之旅！",
      "instructions": "我的農場是一款引人入勝的農場遊戲，擁有一個經過驗證、受百萬玩家喜愛的遊戲公式！發展您的農場，生產新型態的產品，並完成令人興奮的任務！獲得珍稀箱包、稀有動物和色彩繽紛的裝飾為您的農場增添色彩！尋找您的朋友，並結交新朋友！一起創建農民公會，互相送禮物，並參加扣人心弦的比賽和有趣的主題慶典！",
      "genres": [
        "模擬"
      ],
      "tags": [
        "農場"
      ]
    },
    "zh-HK": {
      "title": "我的農場",
      "description": "成為自豪的農場主人！種植作物、照顧動物、捕魚並設立生產線。在動物園收集珍奇動物，見證神秘訪客，踏上一場刺激的冒險之旅！",
      "instructions": "我的農場是一款引人入勝的農場遊戲，擁有經過時間考驗的遊戲公式，深受數百萬玩家喜愛！發展你的農場，生產新型商品，並完成刺激任務！獲得罕見的寶箱、外來動物和色彩繽紛的裝飾為你的農場添彩！尋找你的朋友並結交新朋友！一起創建農民公會，互相送禮，參與緊張刺激的比賽和有趣的主題慶典！",
      "genres": [
        "模擬"
      ],
      "tags": [
        "農場"
      ]
    },
    "ja": {
      "title": "マイファーム",
      "description": "自分の农场の誇り高い所有者になる！作物を育て、動物を世話する、魚を釣り、生産を設置。動物園で珍しい動物のコレクションを集め、謎の訪問者に会い、スリル満点の冒険に乗り出せ！",
      "instructions": "私の農場は、数百万のプレイヤーに愛される試され尽くされたゲームプレイフォーマットを持つ魅力的な農場ゲームです！あなたの農場を発展させ、新しい種類の商品を製造し、興味深いタスクを完了しましょう！珍しいカスタムボックス、異国の動物、色鮮やかな装飾品をあなたの農場に手に入れましょう！友人を見つけ、新しい人々と交流しましょう！一緒に農民ギルドを作成し、お互いに贈り物をし、緊張感のあるトーナメントや楽しいテーマイベントに参加しましょう！",
      "genres": [
        "シミュレーション"
      ],
      "tags": [
        "農場"
      ]
    },
    "ko": {
      "title": "마이 파ーム",
      "description": "귀하의 독특한 농장을 자랑스럽게 소유하세요! 작물을 심고, 동물을 돌보고, 고기를 잡고, 생산을 설치하세요. 자원감을 모으고, 신비한 방문자를 만나고, 흥미진진한 모험에 떠나세요!",
      "instructions": "마이 팜은 수십만 명의 플레이어에 사랑받는 테스트된 게임 메커니즘을 가진 매력적인 농장 게임입니다! 농장을 개발하고 새로운 유형의 상품을 제조하고 흥미진진한 작업을 완료하세요! 드문 가방, 독특한 동물, 농장을 장식하는 다양한 색상의 장식을 얻으세요! 친구를 찾고 새로운 친구를 만들세요! 함께 농부 길드를 만들고 서로에게 선물을 보내고, 극도의 경쟁과 즐거운 테마 페스티벌에 참가하세요!",
      "genres": [
        "시뮬레이션"
      ],
      "tags": [
        "농장"
      ]
    },
    "fr": {
      "title": "Mon Fermier",
      "description": "Devenez fièrement propriétaire de votre propre ferme ! Cultivez des cultures, prenez soin des animaux, capturez des poissons et mettez en place des productions. Assemblez des collections d'animaux exotiques dans le zoo, rencontrez des visiteurs mystérieux et embarquez dans des aventures captivantes !",
      "instructions": "Mon Ferme est un jeu de ferme captivant, avec une formule de jeu éprouvée et aimée par des millions de joueurs ! Développez votre ferme, fabriquez de nouveaux types de produits, et accomplissez des tâches captivantes ! Obtenez des coffres rares, des animaux exotiques et des décorations colorées pour votre ferme ! Trouvez vos amis et faites de nouveaux contacts ! Créez des guildes de fermiers ensemble, envoyez-vous des cadeaux, et participez à des tournois passionnants et à des fêtes thématiques amusantes !",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "ferme"
      ]
    }
  }
};
